import { render, staticRenderFns } from "./AddUpdateNew.vue?vue&type=template&id=00b2f251&"
import script from "./AddUpdateNew.vue?vue&type=script&lang=js&"
export * from "./AddUpdateNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports